































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { CURRENCY_FORMAT } from '@/helpers/currency';
import dxCustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import notificationService from '@/services/notificationService';
import machineryEventRepository from '@/modules/machinery/services/machineryEventsRepository';
// import machineriesRepository from '@/modules/machinery/services/machineriesRepository';
import machineryEventTypesRepository from '@/modules/machinery/services/machineryEventTypesRepository';
import cPopup from '@/components/default/Popup.vue';
import cCard from '@/components/default/Card.vue';
import cDatagrid from '@/components/default/Datagrid.vue';
import { DxNavBar } from 'devextreme-vue';
import {
  DxForm,
  DxSimpleItem,
  DxRequiredRule,
  DxGroupItem,
  DxLabel,
} from 'devextreme-vue/form';
import Machinery from '@/modules/machinery/classes/Machinery';

@Component({
  components: {
    cCard,
    cDatagrid,
    cPopup,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxLabel,
    DxNavBar,
  },
})
export default class MachineryEventsTable extends Vue {
    @Prop({required: false})
    private machineryId!: string;

    @Prop({required: false})
    private begin?: string;

    @Prop({required: false})
    private end?: string;

    private showDialogValue: boolean = false;
    private saving: boolean = false;
    private loading: boolean = false;
    private eventTypes: IMachineryEventType[] = [];
    private eventModal: IMachineryUpdateEventCommand = {
        id: '',
        machineryId: '',
        eventTypeId: '',
        description: '',
        title: '',
        date: '',
        price: null,
        operatingHours: null,
    };

    public add() {
        Object.assign(this.eventModal, {
            id: '',
            machineryId: this.machineryId,
            eventTypeId: '',
            description: '',
            title: '',
            date: '',
            price: null,
            operatingHours: null,
        });
        this.showDialogValue = true;
    }

    private mounted() {
        this.eventModal.machineryId = this.machineryId;
        this.loadEventTypesAsync();
    }

    private async loadEventTypesAsync() {
        try {
            this.loading = true;
            this.eventTypes = (await machineryEventTypesRepository.getAll()).data;
        } catch (err) {
            notificationService.showAxiosError(err);
        } finally {
            this.loading = false;
        }
    }

    private editRow(e: any) {
        if (e && e.row && !e.row.isEditing && e.column && e.column.type !== 'buttons') {
            this.$router.push({ path: `/machinery/${e.data.machineryId}/events/${e.data.id}` });
        }
    }

    private async deleteRow(e: any) {
        const self = this;
        e.cancel = new Promise(async (resolve, reject) => {
            try {
                await machineryEventRepository.delete(e.data.id);
                notificationService.saved();
                setTimeout(() => {
                    self.refresh();
                }, 300);
                resolve(true);
            } catch (err) {
                notificationService.showAxiosError(err);
                resolve(true);
            }
        });
    }

    private async saveEvent() {
        try {
            const validationResult = (this.$refs.machineryEventForm as any).instance.validate();
            if (validationResult.isValid) {
                this.saving = true;
                if (this.eventModal.id !== '') {
                    // Update
                    await machineryEventRepository.update(this.eventModal);
                } else {
                    // Create
                    await machineryEventRepository.create(this.eventModal);
                }
                this.refresh();
                notificationService.saved();
                this.showDialogValue = false;
            } else {
                notificationService.invalidForm();
            }
        } catch (err) {
            notificationService.showAxiosError(err);
        } finally {
            this.saving = false;
        }
    }

    private refresh() {
      try {
        ((this.$refs.eventGrid as cDatagrid).$refs.machineEventGrid as any).instance.refresh();
      } catch {
        // do nothing
      }
    }

    get navbarItems() {
        return [
            { icon: 'fas fa-info-circle', text: 'Data'},
            { icon: 'fas fa-file-contract', text: 'Contracten'},
            { icon: 'fas fa-bell', text: 'Events'},
            { icon: 'fas fa-calendar-alt', text: 'Verhuur'},
        ];
    }

  get eventFields() {
    return [
        {
            itemType: 'simple',
            dataField: 'eventTypeId',
            editorOptions: {
                items: this.eventTypes,
                displayExpr: 'name',
                valueExpr: 'id',
                searchEnabled: true,
                itemTemplate: (e: any) => {
                    let customHtml = e.name;
                    if (e.icon) {
                        customHtml = '<i class="fas ' + e.icon + '"></i>&nbsp;' + customHtml;
                    }

                    return customHtml;
                },
            },
            editorType: 'dxSelectBox',
            label: {
                text: this.$t('objects.machineryEvent.fields.Type'),
            },
            validationRules: [
                {type: 'required', message: 'Veld is verplicht'},
            ],
        },
        {
            itemType: 'simple',
            dataField: 'title',
            label: {
                text: this.$t('objects.machineryEvent.fields.Title'),
            },
            validationRules: [
                {type: 'required', message: 'Veld is verplicht'},
            ],
        },
        {
            itemType: 'simple',
            dataField: 'date',
            editorOptions: { width: '100%', useMaskBehavior: true },
            editorType: 'dxDateBox',
            label: {
                text: this.$t('objects.machineryEvent.fields.Date'),
            },
            validationRules: [
                {type: 'required', message: 'Veld is verplicht'},
            ],
        },
        {
            itemType: 'group',
            colCount: 2,
            items: [
                {
                    itemType: 'simple',
                    dataField: 'price',
                    editorType: 'dxNumberBox',
                    editorOptions: {
                        format: CURRENCY_FORMAT,
                    },
                    label: {
                        text: this.$t('objects.machineryEvent.fields.Price'),
                    },
                },
                {
                    itemType: 'simple',
                    dataField: 'operatingHours',
                    editorType: 'dxNumberBox',
                    label: {
                        text: 'Draaiuren / KM-stand',
                    },
                },
            ],
        },
        {
            itemType: 'simple',
            dataField: 'description',
            editorType: 'dxTextArea',
            editorOptions: { height: '150'},
            label: {
                text: this.$t('objects.machineryEvent.fields.Description'),
            },
        },
    ];
  }

    get eventGridColumns() {
        const self = this;
        return [
            {
                caption: 'Event',
                cellTemplate: (cellElement: any, cellInfo: any) => {
                    const eventType = self.eventTypes.find((o: IMachineryEventType) => o.id === cellInfo.data.typeId);
                    if (cellInfo.data) {
                        return $(cellElement).append(`<i class='fas ${cellInfo.data.icon}'></i> ${cellInfo.data.type}`);
                    }
                    return cellElement;
                },
            },
            {
                dataField: 'machineryName',
                caption: 'Machine',
                allowFiltering: false,
            },
            {
                dataField: 'title',
                caption: this.$t('objects.machineryEvent.fields.Title'),
            },
            {
                dataField: 'date',
                caption: this.$t('objects.machineryEvent.fields.Date'),
                dataType: 'date',
            },
            {
                dataField: 'price',
                caption: this.$t('objects.machineryEvent.fields.Price'),
                format: CURRENCY_FORMAT,
                alignment: 'left',
            },
            {
                dataField: 'operatingHours',
                caption: 'Draaiuren / KM-stand',
                alignment: 'left',
            },
            {
                type: 'buttons',
                buttons: ['edit', 'delete'],
            },
        ];
    }

    get dialogTitle() {
        return this.eventModal.id === '' ? 'Event toevoegen' : 'Event wijzigen';
    }

    get datasource() {
        const self = this;
        return new DataSource({
            store: new dxCustomStore({
                key: 'id',
                load: async (loadOptions) => {
                    if (this.begin && this.end) {
                        loadOptions.filter = [
                            [ 'date', '>=', this.begin ],
                            'and',
                            [ 'date', '<', this.end ],
                        ];
                    } else {
                        if (this.begin) {
                            loadOptions.filter = [ 'date', '>=', this.begin ];
                        }
                    }

                /*data: result.data.data,
                    totalCount: result.data.totalCount,*/
                    const result = await machineryEventRepository
                        .lookup(loadOptions, this.machineryId);
                    return result.data;
                },
            }),
            paginate: true,
        });
    }
}
